<button mat-button class="button--error">
	<ogs-m3-icon matButtonIcon icon="trash-can"/>
	Löschen
</button>
